module.exports = __webpack_public_path__ + "img/logo-big-core.36144fb0.png";